export { WebEncryptionService as EncryptionService } from './web-encryption-service.web';
export type { EncryptionConfig } from './webview-encryption-service';
